/* src/app/modal/add-alarm/add-alarm.component.scss */
.levels li {
  float: left;
}
.languages {
  margin-top: 122px;
}
.levels li,
.languages li {
  padding: 5px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.levels li.active,
.languages li.active {
  background-color: rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=add-alarm.component.css.map */
